"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionContent = exports.AccordionSubLabel = exports.AccordionLabel = exports.StyledArrow = exports.AccordionBox = exports.AccordionBody = exports.AccordionTitle = exports.AccordionHeader = exports.AccordionItem = exports.AccordionInner = void 0;
const theme_1 = require("@pulse-web-ui/theme");
exports.AccordionInner = theme_1.styled.div `
  position: relative;
  width: 100%;
  pointer-events: all;
  box-sizing: border-box;
  ${({ variant }) => variant === 'outlined' &&
    (0, theme_1.css) `
      border: 1px solid ${({ theme }) => theme.colors.neutral['30']};
    `}
  ${({ size, hasLabel }) => {
    switch (size) {
        case 'xs':
            return (0, theme_1.css) `
          border-radius: ${({ theme }) => { var _a; return (_a = theme.common.radius12) !== null && _a !== void 0 ? _a : `calc(${theme.common.radius} * 4)`; }};
          padding: 0;

          header {
            padding: 12px;

            h3 {
              ${theme_1.typography.medium14}
            }
          }
        `;
        case 's':
            return (0, theme_1.css) `
          border-radius: ${({ theme }) => { var _a; return (_a = theme.common.radius12) !== null && _a !== void 0 ? _a : `calc(${theme.common.radius} * 4)`; }};
          padding-bottom: 16px;

          header {
            padding: 16px 16px 0 16px;

            h3 {
              ${theme_1.typography.medium16}
            }
          }
          section {
            padding: 8px 16px 0 16px;
          }
        `;
        case 'm':
            return (0, theme_1.css) `
          border-radius: ${({ theme }) => { var _a; return (_a = theme.common.radius12) !== null && _a !== void 0 ? _a : `calc(${theme.common.radius} * 4)`; }};
          ${hasLabel
                ? (0, theme_1.css) `
                padding-bottom: 16px;
              `
                : (0, theme_1.css) `
                padding-bottom: 24px;
              `}

          header {
            ${hasLabel
                ? (0, theme_1.css) `
                  padding: 16px 24px 0 24px;
                `
                : (0, theme_1.css) `
                  padding: 24px 24px 0 24px;
                `}

            h3 {
              ${theme_1.typography.medium20}
            }
          }
          section {
            padding: 0 24px;
            padding-top: 12px;
          }
        `;
        case 'l':
            return (0, theme_1.css) `
          border-radius: ${({ theme }) => `calc(${theme.common.radius} * 6)`};
          ${hasLabel
                ? (0, theme_1.css) `
                padding-bottom: 24px;
              `
                : (0, theme_1.css) `
                padding-bottom: 32px;
              `}
          header {
            ${hasLabel
                ? (0, theme_1.css) `
                  padding: 24px 32px 0 32px;
                `
                : (0, theme_1.css) `
                  padding: 32px 32px 0 32px;
                `}

            h3 {
              ${theme_1.typography.medium24}
            }
          }
          section {
            padding: 0 32px;
            padding-top: 12px;
          }
        `;
        default:
            return null;
    }
}}

  ${({ color, variant }) => {
    switch (color) {
        case 'surface':
            return (0, theme_1.css) `
          ${variant === 'filled' &&
                (0, theme_1.css) `
            background-color: ${({ theme }) => theme.colors.surface.background};

            &:hover {
              ${variant === 'filled' &&
                    (0, theme_1.css) `
                background-color: ${({ theme }) => theme.colors.surface.secondary};
              `}
            }
          `}
        `;
        case 'white':
            return (0, theme_1.css) `
          background-color: ${({ theme }) => theme.colors.surface.primary}; ;
        `;
        default:
            return null;
    }
}}

  ${({ variant, isOpened }) => {
    if (variant === 'outlined' && isOpened) {
        return (0, theme_1.css) `
        background-color: ${({ theme }) => theme.colors.neutral['30']};
      `;
    }
}}
`;
exports.AccordionItem = theme_1.styled.div `
  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.neutral['30']};
  }
`;
exports.AccordionHeader = theme_1.styled.header `
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.text.primary};
  ${({ variant, isOpened }) => {
    if (variant === 'outlined') {
        return (0, theme_1.css) `
        background-color: ${({ theme }) => theme.colors.surface.background};
        ${isOpened
            ? (0, theme_1.css) `
              border-top-left-radius: ${({ theme }) => { var _a; return (_a = theme.common.radius12) !== null && _a !== void 0 ? _a : `calc(${theme.common.radius} * 4)`; }};
              border-top-right-radius: ${({ theme }) => { var _a; return (_a = theme.common.radius12) !== null && _a !== void 0 ? _a : `calc(${theme.common.radius} * 4)`; }};
              border-bottom: 1px solid
                ${({ theme }) => theme.colors.neutral['30']};
            `
            : (0, theme_1.css) `
              border-radius: ${({ theme }) => { var _a; return (_a = theme.common.radius12) !== null && _a !== void 0 ? _a : `calc(${theme.common.radius} * 4)`; }};
            `}
      `;
    }
}}

  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    ${({ isOpened }) => isOpened &&
    (0, theme_1.css) `
        height: 0;
      `}
  }
`;
exports.AccordionTitle = theme_1.styled.h3 `
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0;
`;
exports.AccordionBody = theme_1.styled.div `
  display: block;
  position: relative;
  padding: 0;
  margin: 0;
  overflow: hidden;
  transition: height 0.3s;

  ${({ variant }) => {
    if (variant === 'outlined') {
        return (0, theme_1.css) `
        background-color: ${({ theme }) => theme.colors.surface.primary};
        border-bottom-left-radius: ${({ theme }) => { var _a; return (_a = theme.common.radius12) !== null && _a !== void 0 ? _a : `calc(${theme.common.radius} * 4)`; }};
        border-bottom-right-radius: ${({ theme }) => { var _a; return (_a = theme.common.radius12) !== null && _a !== void 0 ? _a : `calc(${theme.common.radius} * 4)`; }};
      `;
    }
}}

  ${({ bodyHeight }) => (0, theme_1.css) `
      height: ${bodyHeight};
    `}
`;
exports.AccordionBox = theme_1.styled.section `
  height: auto;

  ${({ size }) => {
    if (size === 'xs') {
        return (0, theme_1.css) `
        padding: 8px 12px;
      `;
    }
}}
`;
exports.StyledArrow = theme_1.styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  pointer-events: none;
`;
exports.AccordionLabel = theme_1.styled.div `
  color: ${({ theme }) => theme.colors.text.secondary};
  ${theme_1.typography.regular14}
  line-height: 20px;
`;
exports.AccordionSubLabel = theme_1.styled.div `
  color: ${({ theme }) => theme.colors.text.primary};
  ${theme_1.typography.medium20}
`;
exports.AccordionContent = theme_1.styled.div ``;
